import { request } from './request'

/**
 * 商品及购物车接口
 * 需要认证的接口会自动从 localStorage.user.token 读取 token
 */
export const goodsApi = {
  /** 添加购物车 */
  addCart(data) {
    return request('/api/goods/addcart', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 购物车列表 */
  getCartList() {
    return request('/api/goods/cartlist', {
      method: 'POST',
      formData: true
    })
  },

  /** 删除购物车 */
  deleteCart(data) {
    return request('/api/goods/delcart', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 编辑加购数量 */
  editCounts(data) {
    return request('/api/goods/editcounts', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 得到确定订单页面信息 */
  getOrderInfo(data) {
    return request('/api/goods/getorderinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 商品详情 */
  getGoodsInfo(data) {
    return request('/api/goods/goodsinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },
  /** 商品列表 */
  getGoodsList(data) {
    return request('/api/goods/goodslist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 下单调取支付 */
  toPay(data) {
    return request('/api/goods/topay', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 订单列表 */
  getOrderList(data) {
    return request('/api/goods/orderlist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 订单详情 */
  getOrderDetail(data) {
    return request('/api/goods/orderinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 查询支付订单状态 */
  payQuery(data) {
    return request('/api/goods/payquery', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 查询USDT订单状态是否已支付 */
  usdtQuery(data) {
    return request('/api/goods/usdtquery', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 未支付订单继续支付 */
  payAgain(data) {
    return request('/api/goods/payagain', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 取消订单 */
  cancelOrder(data) {
    return request('/api/goods/cancelorder', {
      method: 'POST',
      formData: true,
      body: data
    })
  }
}
